module.exports = require("moment");


//////////////////
// WEBPACK FOOTER
// external "moment"
// module id = 38
// module chunks = 0